import { render, staticRenderFns } from "./DocumentsContent.vue?vue&type=template&id=5c578b8e&scoped=true&"
import script from "./DocumentsContent.vue?vue&type=script&lang=js&"
export * from "./DocumentsContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsContent.vue?vue&type=style&index=0&id=5c578b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c578b8e",
  null
  
)

export default component.exports